import React from "react";
import { Text, View } from "@react-pdf/renderer";

const TableRow = ({ style, children }) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      textAlign: "center",
      ...style,
    }}
  >
    {children}
  </View>
);

const TableCell = ({ style, children }) => (
  <View
    style={{
      flex: 1,
      // borderRight: "1 solid black",
      // borderBottom: "1 solid black",
      paddingRight: 3,
      paddingTop: 3,
      paddingBottom: 3,
      textAlign: "right",
      direction: "ltr",
      ...style,
    }}
  >
    <Text>{children}</Text>
  </View>
);

class TextPdfFix extends React.Component {
  render() {
    const { text } = this.props;

    const spl = text.split(" ");

    if (Array.isArray(spl) && spl.length > 0)
      return (
        <TableRow>
          {spl.reverse().map((s) => {
            return <TableCell> {s} </TableCell>;
          })}
        </TableRow>
      );
    else return <TableCell>-</TableCell>;
  }
}

export default TextPdfFix;
